import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Laura M.',
    role: 'Profesora de Historia',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
    quote: 'Cuando encontré esta colección sentí un alivio enorme. Tenía actividades y presentaciones listas.',
    rating: 5
  }, {
    name: 'Mariana G.',
    role: 'Profesora de Historia',
    image: 'https://randomuser.me/api/portraits/women/68.jpg',
    quote: 'Fue la primera vez en años que comencé el ciclo lectivo con casi todo organizado.',
    rating: 5
  }, {
    name: 'Carlos A.',
    role: 'Profesor de Historia',
    image: 'https://randomuser.me/api/portraits/men/52.jpg',
    quote: 'Nunca había encontrado un material tan completo. Me ahorraron semanas de trabajo.',
    rating: 5
  }];
  return <section className="bg-[#EDF1F5] py-8 px-4" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-bold text-[#424E60] uppercase text-center mb-6" data-id="element-194">
          LO QUE OTROS DOCENTES ESTÁN DICIENDO
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-195">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-lg px-4 py-3 shadow-sm border-l-3 border-[#586880] relative" style={{
          borderLeftWidth: '3px'
        }} data-id="element-196">
              <Quote size={14} className="text-[#E2DED6] absolute top-2 right-3" data-id="element-197" />
              <div className="flex items-center gap-2 mb-2" data-id="element-198">
                <img src={testimonial.image} alt={testimonial.name} className="w-8 h-8 rounded-full object-cover" data-id="element-199" />
                <div className="flex-1 min-w-0" data-id="element-200">
                  <h4 className="font-bold text-[#424E60] text-xs leading-tight" data-id="element-201">
                    {testimonial.name}
                  </h4>
                  <p className="text-[#586880] text-[10px]" data-id="element-202">
                    {testimonial.role}
                  </p>
                </div>
                <div className="flex text-yellow-500" data-id="element-203">
                  {[...Array(5)].map((_, i) => <Star key={i} size={10} fill="currentColor" data-id="element-204" />)}
                </div>
              </div>
              <p className="text-[#424E60] text-xs italic leading-snug" data-id="element-205">
                "{testimonial.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}